import {Component, OnInit} from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {AngularFireAnalytics} from "@angular/fire/analytics";
import {AuthService} from "./shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmDialogComponent} from "./modules/main/confirm-dialog/confirm-dialog.component";
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'tennis-crm';
  showFiller = true;

  sidenavMode: 'side' | 'push' | 'over' = 'side';
  sidenavOpened = true;

  constructor(
    public breakpointObserver: BreakpointObserver,
    public analytics: AngularFireAnalytics,
    private authService: AuthService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 600px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.sidenavMode = 'over';
          this.sidenavOpened = false;
        } else {
          this.sidenavMode = 'side';
        }
      });
    this.checkRules();
    // this.checkVote();
  }

  checkRules() {
    this.authService.user$.subscribe(user => {
      if (user && !user.confirmPolicy) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '350px',
        });

        dialogRef.componentInstance.title = 'Підтвердження';
        dialogRef.componentInstance.confirmMessage = 'Як учасник організації, я погоджуюся з законом <a href="https://zakon.rada.gov.ua/laws/show/4572-17" target="_blank">Про громадські об\'єднання</a>';
        dialogRef.componentInstance.confirmActionText = 'Погодитися';

        dialogRef.componentInstance.onConfirm
          .subscribe(data => {
            if (data === true) {
              this.authService.confirmPolicy(user.uid).pipe(take(1)).subscribe();
            }
          });
      }
    });
  }

  checkVote() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {

    });

    dialogRef.componentInstance.title = 'Голосування';
    dialogRef.componentInstance.confirmMessage = `<p>💫 НАШ Спільний ШАНС отримати ПРОФЕСІНІ тенісні КОРТИ високої якості з усіма Умовами для тренувань і гри &nbsp;</p>
<p>💫 ЗДІЙСНЕМО МРІЮ РАЗОМ з розвитку найблагороднішого виду спорту у найспортивнішій громаді Київської області</p>
<p>Підтримайте проект ТЕНІСНІ КОРТИ &ldquo;МІКС&rdquo; за посиланням: 💫</p>
<p><a href="https://budget.e-dem.ua/3222410600/project/18475?compid=2413">https://budget.e-dem.ua/3222410600/project/18475?compid=2413</a></p>
<p>Якщо ви проживаєте, але не прописані у Вишневому підтримати проект можна в гугл формі:</p>
<p><a href="https://docs.google.com/forms/d/e/1FAIpQLSd_mZ8KrT8sWFkr2P7Ovfua_MiFzoi_Lbzd8TBhwO4gBvwlVQ/viewform" rel="noopener noreferrer" target="_blank">Google форма для голосування</a></p>
<p>🤗Підтримайте МОЄ постійне намагання вивести тенісний рух в громаді на високий рівень</p>
<p>&nbsp;🙋&zwj;♂️Залучайте знайомих та друзів до голосування</p>
<p>З повагою, Гудима Ярослав</p>`;
    dialogRef.componentInstance.confirmActionText = 'Вже Проголосував';

    dialogRef.componentInstance.onConfirm
      .subscribe(data => {
        if (data === true) {
          this.analytics.logEvent('vote courts', {label: 'vote courts'});
        }
      });
  }
}
